import { Component } from "react";
import auth from "../services/authService";

class Logout extends Component {
  componentDidMount() {
    // this.props.handleLogOut();
    auth.logout();
    // this.props.userStatus();
    window.location =
      "https://login.vicuscapital.com/logout.html?from=https://compliance.vicuscapital.com";
  }
  render() {
    return null;
  }
}

export default Logout;
